import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "navbar-theme"

  connect() {
    super.connect()
    const theme = {
      // Semantic chrome (Tribu / new apps)
      window_color: this.bridgeElement.bridgeAttribute("window-color"),
      navbar_color: this.bridgeElement.bridgeAttribute("navbar-color"),
      navbar_ink: this.bridgeElement.bridgeAttribute("navbar-ink"),
      accent_color: this.bridgeElement.bridgeAttribute("accent-color"),
      status_bar_style: this.bridgeElement.bridgeAttribute("status-bar-style"),
      // Legacy (Girls Lab / older clients)
      background_color: this.bridgeElement.bridgeAttribute("background-color"),
      background_light_color: this.bridgeElement.bridgeAttribute("background-light-color"),
      primary_color: this.bridgeElement.bridgeAttribute("primary-color"),
      primary_light_color: this.bridgeElement.bridgeAttribute("primary-light-color"),
      button_primary_bg_color: this.bridgeElement.bridgeAttribute("button-primary-bg-color")
    }
    this.send("connect", theme)
  }
}
